export default (paramString) => {
  const paramArray = paramString.slice(1).split('&');
  const paramObject = paramArray.reduce((acc, keyAndValue) => {
    acc[keyAndValue.split('=')[0]] = keyAndValue.split('=')[1];
    return acc;
  }, {});
  return paramObject;
};


// WEBPACK FOOTER //
// ./src/components/universal/utils/paramParse.js